import { render, staticRenderFns } from "./ViewTransferOrder.vue?vue&type=template&id=da4e4004&"
import script from "./ViewTransferOrder.vue?vue&type=script&lang=js&"
export * from "./ViewTransferOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports